import React from 'react'
import { useSelector } from 'react-redux'

import { Fab, Grid, makeStyles, Typography } from '@material-ui/core'
import { Place } from '@material-ui/icons'
import { grey } from '@material-ui/core/colors'

import { selectStores } from '~/selectors'
import { formatDistance } from '~/utils'

const useStyles = makeStyles(() => ({
  fabRoot: {
    transition: 'all 0.2s',
    backgroundColor: 'transparent',
    boxShadow: 'none',
    '&:hover': { backgroundColor: grey[100] }
  },
  contentRoute: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'initial'
  }
}))

function ButtonStoreRoute({ mapRouteCommunProps }) {
  const classes = useStyles()

  const { currentStore } = useSelector(selectStores)

  return (
    <Fab
      disableFocusRipple
      disableRipple
      variant="circular"
      {...mapRouteCommunProps}
      classes={{ root: classes.fabRoot }}
    >
      <Grid className={classes.contentRoute}>
        <Place fontSize="small" color="primary" />
        <Typography>{formatDistance(currentStore?.distance || 0)}</Typography>
      </Grid>
    </Fab>
  )
}

export default ButtonStoreRoute
